module.exports = __webpack_public_path__ + "static/happy-89f491062c7631125d072e41a6de7089.png";